import { Avatar, Backdrop, Badge, Box, CircularProgress, Grid, IconButton, InputAdornment, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { getUserAttributes, invokeIfCallable, updateUserAttributes } from '../../library/shared';
import { Modal } from './Modal';
import CustomInputBox from '../customInputBox/CustomInputBox';
import { fetchUserPreference, resetUserPreference } from '../../redux/reducers/UserPreference';
import { AccessTime, AccountCircle, Email, StarBorder } from '@mui/icons-material';
import CustomPhoneInputBox from '../customInputBox/CustomPhoneInputBox';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { updateUserDetailsOnSignIn } from '../../redux/reducers/userDetails';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import { uploadToServer } from '../../library/upload';
import { supportedImageFileTypes, capitalizeWords } from '../../utils/common';
import { matchIsValidTel } from 'mui-tel-input';
import { useThemes } from '../../components/Theme/theme';
import { API, graphqlOperation } from 'aws-amplify';
import { createUserPreference } from '../../graphql';
import API_ENDPOINTS from '../../apiEndpoints';

const ProfileSettings = ({ open, setOpen }) => {
  const { theme } = useThemes();
  const [Loading, setLoading] = useState(false);
  let userData = useSelector((state) => state.userDetailsReducer?.userDetails);
  console.log({ userData });
  const userPreferenceIdleTime = useSelector((state) => state.userPrefrenceandReducer);
  const idleTime = userPreferenceIdleTime.userPreference.find((pref) => pref.attributetypecd === 'IdleTime')?.attributevalue;

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [state, setState] = useState({
    name: '',
    lastName: '',
    mobile: '',
    email: '',
    open: false,
    designation: '',
    url: '',
    idleTime: 5,
    errorStatus: {
      name: false,
      mobile: false,
      email: false,
      designation: false,
      idleTime: false,
    },
    errorFields: {
      name: '',
      mobile: '',
      email: '',
      open: '',
      designation: '',
      idleTime: '',
    },
  });

  useEffect(() => {
    if (userData) {
      setState((prev) => ({
        ...prev,
        name: userData.name,
        lastName: userData.lastName,
        mobile: userData.phone_number,
        email: userData.email,
        designation: userData.designation,
        url: userData.picture,
        idleTime: idleTime || 5,
      }));
    }
    return () => {};
  }, [userData, userPreferenceIdleTime]);

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason === 'saved') {
      return setOpen(false);
    }
    if (userData.name && userData.phone_number) {
      setOpen(false);
    } else {
      showWarningSnackbar('Please fill the required fields');
    }
  };

  let dispatch = useDispatch();

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's' && open) {
        e.preventDefault();
        saveFn();
      }
    };
    window.addEventListener('keydown', controlAndS);
    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, [state]);

  const saveFn = async () => {
    try {
      setLoading(true);
      let valid = true;
      let errorFld = Object.keys(state.errorStatus).filter((key) => state.errorStatus[key]);
      console.log(errorFld);

      if (!state.name || state.name?.length == 0) {
        setState((prev) => ({
          ...prev,
          errorFields: { ...prev.errorFields, name: 'First Name is Required' },
          errorStatus: { ...prev.errorStatus, name: true },
        }));
        return showWarningSnackbar('First Name is Required');
      }
      if (!state.mobile || state.mobile?.length < 10) {
        setState((prev) => ({
          ...prev,
          errorFields: {
            ...prev.errorFields,
            mobile: 'Mobile Number is Required',
          },
          errorStatus: { ...prev.errorStatus, mobile: true },
        }));
        return showWarningSnackbar('Mobile Number is Required');
      }
      let numValue = state?.idleTime === '' ? 0 : parseInt(state?.idleTime, 10);

      if (isNaN(numValue) || numValue < 0 || numValue > 60) return; // Invalid range or non-numeric value, do nothing

      if (numValue === 0) {
        setState((prev) => ({
          ...prev,
          idleTime: numValue,
          errorStatus: { ...prev.errorStatus, idleTime: true },
          errorFields: {
            ...prev.errorFields,
            idleTime: 'Application Inactivity Timeout is required',
          },
        }));
      } else if (numValue < 5) {
        setState((prev) => ({
          ...prev,
          idleTime: numValue,
          errorStatus: { ...prev.errorStatus, idleTime: true },
          errorFields: {
            ...prev.errorFields,
            idleTime: 'The Minimum Application Inactivity Timeout limit should be 5 minutes',
          },
        }));
        return;
      } else {
        setState((prev) => ({
          ...prev,
          idleTime: numValue,
          errorStatus: { ...prev.errorStatus, idleTime: false },
          errorFields: { ...prev.errorFields, idleTime: '' },
        }));
      }

      if (errorFld.length > 0) {
        showWarningSnackbar(errorFld.length == 1 ? state.errorFields[errorFld[0]] : 'Fill the Required fields');
        valid = false;
      }
      if (valid) {
        // const res = await API.graphql(
        //     graphqlOperation(updateprofiledetails, {
        //         CompanyName: state.name, PhoneNumber: state.phone, EmailAddress: state.email
        //     })
        // );
        let payLoad = [
          { Name: 'custom:Designation', Value: state.designation },
          // { Name: "custom:idletime", Value: String(state.idleTime) },
          state.name.length ? { Name: 'name', Value: state.name } : null,
          {
            Name: 'phone_number',
            Value: state.mobile == '+91' ? '' : state.mobile.replace(/\s+/g, ''),
          },
          { Name: 'picture', Value: state.url },
          { Name: 'family_name', Value: state.lastName || '' },
        ].filter((elem) => elem != null);
        console.log(payLoad, imageFile);
        if (imageFile) {
          const fileExtension = imageFile.type?.split('/')[1];
          let fileName = `avatar/${userData.userName + '_' + Date.now() + '.' + fileExtension}`;
          await uploadToServer(imageFile, fileName, imageFile.type);
          payLoad.push({
            Name: 'picture',
            Value: API_ENDPOINTS.REACT_APP_S3_BUCKET_URL + '/' + fileName,
          });
        }
        await updateUserAttributes(payLoad);
        addIdleTime(numValue);

        let updatedUserData = await getUserAttributes();
        dispatch(updateUserDetailsOnSignIn(updatedUserData));
        localStorage.setItem('UserName', state.name);
        showSuccessSnackbar('Profile Settings Updated');
        handleClose('', 'saved');
      }
    } catch (error) {
      console.log(error, 'error');
      showWarningSnackbar('Something went wrong !');
    } finally {
      setLoading(false);
    }
  };
  async function addIdleTime(value) {
    try {
      const userPreferenceData = {
        additionalvalue: '',
        attributetypecd: 'IdleTime',
        attributevalue: Number(value),
      };
      const swicthFYres = await API.graphql(
        graphqlOperation(createUserPreference, {
          createUserPreferenceInput: userPreferenceData,
        })
      );
      dispatch(fetchUserPreference());
    } catch (error) {
      setOpen(true);
      console.log('error', error);
    }
  }
  const handleMobileChange = (newPhone) => {
    if (newPhone == '' || newPhone == '+91') {
      setState((prev) => ({
        ...prev,
        mobile: newPhone,
        errorStatus: {
          ...prev.errorStatus,
          mobile: false,
        },
        errorFields: {
          ...prev.errorFields,
          mobile: 'Mobile Number is Required',
        },
      }));
    } else if (!matchIsValidTel(newPhone)) {
      setState((prev) => ({
        ...prev,
        mobile: newPhone,
        errorStatus: {
          ...prev.errorStatus,
          mobile: true,
        },
        errorFields: {
          ...prev.errorFields,
          mobile: 'Invalid Mobile Number',
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        mobile: newPhone,
        errorStatus: {
          ...prev.errorStatus,
          mobile: false,
        },
        errorFields: {
          ...prev.errorFields,
          mobile: '',
        },
      }));
    }
  };
  let companyDetails = useSelector((state) => state?.companyReducer?.companyDetails);
  const [imageFile, setImageFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!supportedImageFileTypes.includes(file.type)) {
        showErrorSnackbar('Unsupported file type. Please select an image file (jpg, jpeg, png).');
        return;
      } else {
        setImageFile(file);
        const newAvatarUrl = URL.createObjectURL(file);
        setState((prev) => ({ ...prev, url: newAvatarUrl }));
      }

      // Revoke the object URL after the image is loaded
    }
  };
  return (
    <>
      {Loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: 999999,
            position: 'absolute',
          }}
          open={Loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Modal open={open} onClose={handleClose} sx={{ zIndex: 1300 }}>
        <Paper>
          <Modal.Header>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 10px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  Profile Settings
                  <IconButton aria-label="delete" className="btn" onClick={() => invokeIfCallable(handleClose)}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
          </Modal.Header>
          <Modal.Body>
            <Paper
              sx={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
                padding: { sm: '7px 20px', xs: '7px 8px' },
                borderRadius: '0 7px',
                transition: 'all 2s ease-in-out',
                '&:hover': {
                  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
                },
                width: { xs: '95%', sm: '450px' },
                // minWidth: '350px'
                overflowX: 'hidden',
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                      <IconButton
                        sx={{
                          // position: 'relative',
                          // right: "-58%",
                          // top: "-40px",
                          border: '4px solid #dbc9c9',
                          borderRadius: '50%',
                          background: theme.palette.bodyGray.main,
                          borderColor: theme.palette.secondary.main,
                          padding: '4px',
                          '&:hover': {
                            backgroundColor: 'grey.200',
                          },
                        }}
                        onClick={() => {
                          state.url?.length ? handleClickOpen() : fileInputRef.current.click();
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    }
                  >
                    <Avatar
                      alt={userData.name}
                      sx={{
                        height: { sm: '120px', xs: '80px' },
                        width: { sm: '120px', xs: '80px' },
                        border: `4px solid ${theme.palette.secondary.main}`,
                      }}
                      src={state.url}
                    />
                    <input type="file" accept="image/*" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
                  </Badge>
                </Box>
              </Box>
              <Grid container spacing={1} sx={{ marginTop: '10px' }}>
                <Grid item xs={12} md={6}>
                  <CustomInputBox
                    // label={"Company Admin (Full Name)"}
                    label={'First Name'}
                    value={state.name}
                    name="name"
                    required={true}
                    // placeholder="Company Admin (Full Name)"
                    type="text"
                    autoFocus={true}
                    autoComplete="new-password"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      // Capitalize every word in the name
                      const capitalizedValue = capitalizeWords(value);
                      const regex = '';
                      if (capitalizedValue?.length > 20) {
                        return;
                      }
                      if (capitalizedValue == '') {
                        setState((prev) => ({
                          ...prev,
                          [name]: capitalizedValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'First Name is Required',
                          },
                        }));
                      } else if (!new RegExp(/^[a-zA-Z0-9\s]+$/).test(capitalizedValue)) {
                        setState((prev) => ({
                          ...prev,
                          [name]: capitalizedValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'Name Contain Only Alphanumericals',
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          [name]: capitalizedValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      }
                    }}
                    state={state}
                    icon={
                      <AccountCircle
                        sx={{
                          color: state.errorStatus.name === true ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomInputBox
                    value={state.lastName}
                    fullWidth
                    name="lastName"
                    className="smaller-textfield1"
                    size="small"
                    state={state}
                    label={'Last Name'}
                    onChange={(e) => {
                      const { value } = e.target;
                      // Capitalize every word in the name
                      const capitalizedValue = capitalizeWords(value);
                      let name = 'lastName';
                      if (capitalizedValue?.length > 20) {
                        return;
                      }
                      const regex = '';
                      if (capitalizedValue == '') {
                        setState((prev) => ({
                          ...prev,
                          [name]: capitalizedValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      } else if (!new RegExp(/^[a-zA-Z0-9\s]+$/).test(capitalizedValue)) {
                        setState((prev) => ({
                          ...prev,
                          [name]: capitalizedValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'Last Name Contain Only Alphanumericals',
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          [name]: capitalizedValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      }
                    }}
                    // onChange={(e) => {
                    //     setState((prev) => ({
                    //         ...prev,
                    //         lastName: e.target.value
                    //     }))
                    // }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomInputBox
                    value={state.designation}
                    name="designation"
                    label="Designation"
                    type="text"
                    autoFocus={false}
                    autoComplete=""
                    onChange={(e) => {
                      let { name, value } = e.target;
                      value = capitalizeWords(value);
                      if (value?.length > 20) {
                        return;
                      }
                      if (value == '') {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      } else if (!new RegExp(/^[a-zA-Z0-9\s]+$/).test(value)) {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'Designation Contain Only Alphanumericals',
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      }
                    }}
                    state={state}
                    icon={
                      <StarBorder
                        sx={{
                          color: state.errorStatus.designation === true ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomPhoneInputBox
                    // name="phone"
                    label="Mobile"
                    placeholder="Mobile Number"
                    defaultCountry="IN"
                    type="text"
                    required={true}
                    focusOnSelectCountry={true}
                    forceCallingCode={true}
                    disableFormatting={true}
                    onChange={(newPhone) => {
                      handleMobileChange(newPhone);
                    }}
                    state={state}
                    name={'mobile'}
                    value={state.mobile}
                    sx={{
                      outline: 'none',
                      width: '100%',
                      padding: '0px',
                      // borderRadius: "12px",
                      borderRadius: '5px',
                      height: '40px',
                      border: '1px solid #979899',
                      color: 'red',
                      display: 'flex',
                      justifyContent: 'center',
                      '&:focus-within': {
                        border: '1px solid',
                        borderColor: 'primary.main',
                      },
                      '&.MuiOutlinedInput-input': {
                        color: 'red!important',
                      },
                      '& .MuiInputBase-input': {
                        color: '#919191',
                      },
                      '& .MuiInputBase-root': {
                        // Additional internal styling can go here
                      },
                      '& .MuiOutlinedInput-root': {
                        padding: '7px',
                        color: 'red',
                        // Style overrides for the outlined variant
                        '& fieldset': {
                          border: 'none', // Ensure internal MUI components don't override your border
                        },
                        '&:hover fieldset': {
                          border: 'none', // Handle hover state
                        },
                        '&.Mui-focused fieldset': {
                          border: '0', // Handle focus state
                        },
                      },
                    }}
                    inputProps={{
                      style: { border: 'none' },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInputBox
                    value={state.email}
                    name="email"
                    label="Email Address / User Id"
                    type="email"
                    autoFocus={false}
                    disabled={true}
                    required={true}
                    autoComplete="new-password"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      if (value == '') {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'Email is Required',
                          },
                        }));
                      } else if (
                        !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
                          value
                        )
                      ) {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'Invalid Email Address',
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      }
                    }}
                    state={state}
                    icon={
                      <Email
                        sx={{
                          color: state.errorStatus.email === true ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInputBox
                    value={state.idleTime}
                    name="idleTime"
                    label="Application Inactivity Timeout"
                    type="text"
                    autoFocus={false}
                    required={true}
                    onChange={(e) => {
                      const { name, value } = e.target;
                      const numValue = value === '' ? 0 : parseInt(value, 10);

                      if (/^\d*$/.test(value) && numValue >= 0 && numValue <= 60) {
                        let errorMessage = '';

                        if (numValue === 0) {
                          errorMessage = 'Application Inactivity Timeout is required';
                        } else if (numValue < 5) {
                          errorMessage = 'The Minimum Application Inactivity Timeout limit should be 5 minutes';
                        }

                        setState((prev) => ({
                          ...prev,
                          [name]: numValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: !!errorMessage,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: errorMessage,
                          },
                        }));
                      }
                    }}
                    //  InputProps={{
                    //   endAdornment: <InputAdornment position="end">Minutes</InputAdornment>,
                    // }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ mr: '10px' }}>
                          Minutes
                        </InputAdornment>
                      ),
                    }}
                    state={state}
                    icon={
                      <AccessTime
                        sx={{
                          color: state.errorStatus.idleTime === true ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Paper>
          </Modal.Body>
          <Modal.Footer>
            <Box sx={{ display: 'flex', justifyContent: 'end', padding: '10px' }}>
              <LoadingButton
                sx={{
                    backgroundColor:'#EE5B2B','&:hover': {
                    backgroundColor: '#EE5B2B', 
                  },
                }}
                //  loading={loading}
                disableRipple={false}
                loadingPosition="start"
                color="primary"
                startIcon={<SaveIcon />}
                variant="contained"
                onClick={saveFn}
                className="btn"
              >
                Save
              </LoadingButton>
              {/* <Button onClick={getUserAttributes} >
                        refersh
                    </Button> */}
            </Box>
          </Modal.Footer>
        </Paper>
      </Modal>
      <React.Fragment>
        <Dialog open={openDialog} onClose={handleCloseDialog} PaperComponent={Paper} aria-labelledby="draggable-dialog-title">
          <DialogTitle id="draggable-dialog-title">
            <b> Update Profile Picture</b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setState((prev) => ({ ...prev, url: '' }));
                  handleCloseDialog();
                }}
              >
                Remove Picture
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  fileInputRef.current?.click();
                  handleCloseDialog();
                }}
              >
                Upload Picture
              </Button>
            </DialogContentText>
          </DialogContent>
          {/* <DialogActions>
                        <Button autoFocus onClick={handleCloseDialog}>
                            Cancel
                        </Button>
                        <Button onClick={handleCloseDialog}>Subscribe</Button>
                    </DialogActions> */}
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default ProfileSettings;
